import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// Shows a "Number of Lites" selector only when numberOfLites > 1.
// When numberOfLites === 1 the parent already knows it's 1 lite.

const DoorLiteLites = ({ value = '', onChange, numberOfLites = 0, label = 'Lites' }) => {
    const [options, setOptions]   = useState([]);
    const [selected, setSelected] = useState(value);

    useEffect(() => {
        const n = Number(numberOfLites);
        if (!n || n <= 1) { setOptions([]); return; }
        const opts = Array.from({ length: n }, (_, i) => ({
            value: String(i + 1),
            label: `${i + 1} Lite${i + 1 > 1 ? 's' : ''}`,
        }));
        setOptions(opts);
        setSelected(opts[0].value);
        onChange(opts[0].value);
    }, [numberOfLites]);

    if (!options.length) return null;

    const handleChange = (e) => {
        setSelected(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteLites">{label}</label>
            <select id="DoorLiteLites" value={selected} onChange={handleChange}>
                {options.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                ))}
            </select>
        </div>
    );
};

export default DoorLiteLites;
